import { useState, useEffect } from 'react';
import { celestialModeAt, msUntilNextCelestialBoundary } from '../utils/nairobiCelestial';

export function useCelestialMode() {
  const [mode, setMode] = useState(() => celestialModeAt());

  useEffect(() => {
    let timeoutId;

    const scheduleNext = () => {
      const delay = msUntilNextCelestialBoundary();
      timeoutId = window.setTimeout(() => {
        setMode(celestialModeAt());
        scheduleNext();
      }, delay);
    };

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        setMode(celestialModeAt());
        window.clearTimeout(timeoutId);
        scheduleNext();
      }
    };

    scheduleNext();
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      window.clearTimeout(timeoutId);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  return mode;
}
